// removed by extract-text-webpack-plugin
module.exports = {"nf-account-admin":"nf-account-admin","row":"row","nf-account-admin__header":"nf-account-admin__header","nf-account-admin__subheader":"nf-account-admin__subheader","nf-account-admin__side-panel":"nf-account-admin__side-panel","nf-account-admin__add-user":"nf-account-admin__add-user","nf-button--add":"nf-button--add","holder":"holder","button-wrapper":"button-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/AccountAdmin/AccountAdmin.scss
// module id = 5337
// module chunks = 1